module.exports = __webpack_public_path__ + "e672f933174c36345a2595716f77c10a.jpg";